import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import normalize from 'jsonapi-normalizer';
import dates from '@/utils/dates';
import LarvalSitesService from '@/services/LarvalSitesService';

const objectType = 'larvicides';

class LarvicidesService extends BaseService {

  static getList(page) {

    return super.get(`larvicides?page[number]=${page}&page[size]=${this.pageSize()}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static siteSearch(search) {
    return LarvalSitesService.siteSearch(search);
  }

  static search(search, page) {

    return super.get(`larvicides/search?search[field]=${search.field}&search[term]=${search.term}&page[number]=${page}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static getDetails(id) {
    return super.get(`larvicides/${id}`)
      .then((response) => {
        let object = normalize(response.data);
        let data = object.entities[objectType][object.result[objectType][0]];
        data = camelizeKeys(data);

        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static create(data) {

    data = dates.apiFormat(data, ['observedDate']);

    return super.post(objectType, `larvicides`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    data = dates.apiFormat(data, ['observedDate']);

    return super.patch(objectType, `larvicides/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`larvicides/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

}

export default LarvicidesService;